export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      studies: "Studien",
      publications: "Publikationen",
      news: "Lab News",
      admin: "Admin",
      bookAppointment: "Termin buchen",
      logout: "Abmelden"
    },
    // Landing page
    landing: {
      heroTitle: "Willkommen im Learning Brain Lab",
      heroSubtitle: "Wir erforschen, wie sich Lernen, Gedächtnis und kognitive Kontrolle über Kindheit, Jugend und Alter hinweg entwickeln. Helfen Sie uns, die Entwicklung des Gehirns besser zu verstehen.",
      bookNow: "Termin buchen",
      ourResearch: "Unsere Forschung",
      cognitiveDev: "Kognitive Entwicklung",
      cognitiveDevDesc: "Wir untersuchen, wie sich kognitive Fähigkeiten von der Kindheit bis ins hohe Alter entwickeln und verändern.",
      childStudies: "Kinderstudien",
      childStudiesDesc: "Unsere kinderfreundlichen Studien helfen uns zu verstehen, wie junge Gehirne lernen und sich anpassen.",
      flexibleAppts: "Flexible Termine",
      flexibleApptsDesc: "Buchen Sie ganz einfach einen Termin für die Teilnahme an unseren wissenschaftlichen Studien.",
      labEntrance: "Unser Labor in Gebäude D",
      childFriendlyTasks: "Kinderfreundliche Computeraufgaben",
      ourTeam: "Unser Team",
      teamTitle: "Das Learning Brain Lab Team",
      contactUs: "Kontaktieren Sie uns",
      contactDesc: "Haben Sie Fragen zu unseren Studien oder möchten Sie mehr erfahren? Wir freuen uns auf Ihre Nachricht.",
      email: "E-Mail",
      address: "Universitätsring 15, 54296 Trier",
      room: "Raum",
      allRightsReserved: "Alle Rechte vorbehalten."
    },
    // Booking page
    booking: {
      title: "Termin buchen",
      subtitle: "Wählen Sie einen verfügbaren Termin für Ihre Studienteilnahme. Jede Anmeldung umfasst zwei Sitzungen.",
      back: "Zurück",
      selectTimeSlot: "Zeitfenster auswählen",
      selectTimeSlotDesc: "Wählen Sie einen verfügbaren Termin",
      noSlots: "Derzeit sind keine Termine verfügbar. Bitte versuchen Sie es später erneut.",
      selectedSlots: "Ausgewählte Termine:",
      session1: "Sitzung 1",
      session2: "Sitzung 2",
      yourData: "Ihre Daten",
      fillAllFields: "Bitte füllen Sie alle Felder aus",
      surname: "Nachname",
      surnamePlaceholder: "Ihr Nachname",
      email: "E-Mail-Adresse",
      emailPlaceholder: "Ihre E-Mail-Adresse",
      childAge: "Alter des Kindes",
      childAgePlaceholder: "Alter in Jahren",
      childGender: "Geschlecht des Kindes",
      selectGender: "Geschlecht auswählen",
      male: "Männlich",
      female: "Weiblich",
      diverse: "Divers",
      studySelection: "Studienauswahl",
      selectStudy: "Studie auswählen",
      bookAppointment: "Termin buchen",
      booking: "Wird gebucht...",
      successTitle: "Termin gebucht!",
      successMessage: "Vielen Dank für Ihre Anmeldung. Sie haben zwei Sitzungen gebucht:",
      yourAppointments: "Ihre Termine",
      confirmationMessage: "Wir werden uns in Kürze bei Ihnen melden, um den Termin zu bestätigen.",
      backToHome: "Zurück zur Startseite",
      oclock: "Uhr"
    },
    // Admin
    admin: {
      login: "Admin-Anmeldung",
      loginDesc: "Melden Sie sich an, um Termine zu verwalten",
      username: "Benutzername",
      usernamePlaceholder: "Benutzername eingeben",
      password: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      loginBtn: "Anmelden",
      loggingIn: "Anmelden...",
      dashboard: "Admin-Dashboard",
      welcome: "Willkommen",
      appointments: "Termine",
      timeSlots: "Zeitfenster",
      studiesTab: "Studien",
      newsTab: "Lab News",
      appointmentRequests: "Terminanfragen",
      manageRequests: "Verwalten Sie eingehende Terminanfragen",
      noAppointments: "Keine Termine vorhanden",
      surnameCol: "Nachname",
      emailCol: "E-Mail",
      childCol: "Kind",
      studyCol: "Studie",
      statusCol: "Status",
      actionsCol: "Aktionen",
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      suggested: "Neu vorgeschlagen",
      suggestNewDate: "Neuen Termin vorschlagen",
      time: "Uhrzeit",
      suggest: "Vorschlagen",
      addTimeSlot: "Neues Zeitfenster hinzufügen",
      addTimeSlotDesc: "Erstellen Sie ein Zeitfenster mit beiden Sitzungen",
      session1Date: "Sitzung 1 - Datum",
      session1Time: "Sitzung 1 - Uhrzeit",
      session2DateAuto: "Sitzung 2 - Datum (automatisch 7 Tage später)",
      session2Time: "Sitzung 2 - Uhrzeit",
      addSlotBtn: "Zeitfenster hinzufügen",
      availableSlots: "Verfügbare Zeitfenster",
      availableSlotsDesc: "Liste aller Buchungstermine",
      noSlots: "Keine Zeitfenster verfügbar",
      booked: "Gebucht",
      addStudy: "Neue Studie hinzufügen",
      addStudyDesc: "Erstellen Sie eine neue Studie für Buchungen",
      studyName: "Studienname",
      studyNamePlaceholder: "z.B. Spark, Memory Test",
      studyDescription: "Beschreibung (optional)",
      studyDescPlaceholder: "Kurze Beschreibung der Studie",
      addStudyBtn: "Studie hinzufügen",
      activeStudies: "Aktive Studien",
      activeStudiesDesc: "Liste aller verfügbaren Studien",
      noStudies: "Keine Studien vorhanden",
      addNews: "Neue Ankündigung",
      addNewsDesc: "Erstellen Sie eine neue Lab News Ankündigung",
      newsTitleDe: "Titel (Deutsch)",
      newsTitleEn: "Titel (Englisch)",
      newsDescDe: "Beschreibung (Deutsch)",
      newsDescEn: "Beschreibung (Englisch)",
      newsLink: "Link (optional)",
      newsLinkPlaceholder: "https://...",
      addNewsBtn: "Ankündigung hinzufügen",
      allNews: "Alle Ankündigungen",
      allNewsDesc: "Liste aller Lab News",
      noNews: "Keine Ankündigungen vorhanden"
    },
    // Studies page
    studiesPage: {
      title: "Unsere Studien",
      subtitle: "Erfahren Sie mehr über unsere aktuellen Forschungsprojekte und wie Sie teilnehmen können.",
      researchFocus: "Forschungsschwerpunkt",
      researchDesc: "Kindheit und Alter sind geprägt von dramatischen Veränderungen beim Lernen, Gedächtnis und kognitiver Kontrolle. Wir untersuchen, wie diese Prozesse über die Lebensspanne interagieren und wie Gehirnentwicklung, Erfahrung und Umweltfaktoren ihre Entwicklungsverläufe prägen.",
      currentStudies: "Aktuelle Studien",
      kidsInAction: "Kids in Action",
      kidsInActionDesc: "Unsere Studie 'Kids in Action' untersucht die Fähigkeit von Kindern, sich verschiedene Dinge zu merken, ihre Handlungen vorherzusagen und Probleme zu lösen.",
      ageRange: "Alter: 4-10 Jahre",
      lamaStudy: "Lama-Studie",
      lamaStudyDesc: "Unsere 'Lama'-Studie untersucht die Kategorisierungs- und Gedächtnisfähigkeiten von Kindern.",
      stressStudy: "Stress und Neugierde Studie",
      stressStudyDesc: "Diese Studie untersucht den Zusammenhang zwischen Stress und Neugierde. Teilnehmer beantworten Trivia-Fragen und durchlaufen einen Stresstest.",
      adults: "Erwachsene",
      compensation: "Vergütung: 15€/h oder 1 Credit/h",
      duration: "Dauer: ca. 2 Stunden",
      contact: "Kontakt",
      interested: "Interessiert? Kontaktieren Sie uns!",
      participate: "Jetzt teilnehmen"
    },
    // Publications page
    publications: {
      title: "Publikationen",
      subtitle: "Wissenschaftliche Veröffentlichungen unseres Teams",
      requestPdf: "Wenn Sie eine unserer Publikationen als PDF erhalten möchten, kontaktieren Sie uns gerne unter:",
      journalArticles: "Journal Artikel",
      labPosters: "Lab Poster Präsentationen"
    },
    // News page
    news: {
      title: "Lab News",
      subtitle: "Aktuelle Neuigkeiten und Ankündigungen aus unserem Labor",
      noNews: "Derzeit keine Neuigkeiten.",
      readMore: "Mehr erfahren"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      studies: "Studies",
      publications: "Publications",
      news: "Lab News",
      admin: "Admin",
      bookAppointment: "Book Appointment",
      logout: "Logout"
    },
    // Landing page
    landing: {
      heroTitle: "Welcome to the Learning Brain Lab",
      heroSubtitle: "We investigate how learning, memory, and cognitive control develop across childhood, adolescence, and aging. Help us better understand brain development.",
      bookNow: "Book Appointment",
      ourResearch: "Our Research",
      cognitiveDev: "Cognitive Development",
      cognitiveDevDesc: "We study how cognitive abilities develop and change from childhood to old age.",
      childStudies: "Child Studies",
      childStudiesDesc: "Our child-friendly studies help us understand how young brains learn and adapt.",
      flexibleAppts: "Flexible Appointments",
      flexibleApptsDesc: "Easily book an appointment to participate in our scientific studies.",
      labEntrance: "Our lab in Building D",
      childFriendlyTasks: "Child-friendly computer tasks",
      ourTeam: "Our Team",
      teamTitle: "The Learning Brain Lab Team",
      contactUs: "Contact Us",
      contactDesc: "Have questions about our studies or want to learn more? We look forward to hearing from you.",
      email: "Email",
      address: "Universitätsring 15, 54296 Trier",
      room: "Room",
      allRightsReserved: "All rights reserved."
    },
    // Booking page
    booking: {
      title: "Book Appointment",
      subtitle: "Select an available appointment for your study participation. Each registration includes two sessions.",
      back: "Back",
      selectTimeSlot: "Select Time Slot",
      selectTimeSlotDesc: "Choose an available appointment",
      noSlots: "No appointments currently available. Please try again later.",
      selectedSlots: "Selected appointments:",
      session1: "Session 1",
      session2: "Session 2",
      yourData: "Your Information",
      fillAllFields: "Please fill in all fields",
      surname: "Surname",
      surnamePlaceholder: "Your surname",
      email: "Email Address",
      emailPlaceholder: "Your email address",
      childAge: "Child's Age",
      childAgePlaceholder: "Age in years",
      childGender: "Child's Gender",
      selectGender: "Select gender",
      male: "Male",
      female: "Female",
      diverse: "Diverse",
      studySelection: "Study Selection",
      selectStudy: "Select study",
      bookAppointment: "Book Appointment",
      booking: "Booking...",
      successTitle: "Appointment Booked!",
      successMessage: "Thank you for registering. You have booked two sessions:",
      yourAppointments: "Your Appointments",
      confirmationMessage: "We will contact you shortly to confirm your appointment.",
      backToHome: "Back to Home",
      oclock: ""
    },
    // Admin
    admin: {
      login: "Admin Login",
      loginDesc: "Log in to manage appointments",
      username: "Username",
      usernamePlaceholder: "Enter username",
      password: "Password",
      passwordPlaceholder: "Enter password",
      loginBtn: "Login",
      loggingIn: "Logging in...",
      dashboard: "Admin Dashboard",
      welcome: "Welcome",
      appointments: "Appointments",
      timeSlots: "Time Slots",
      studiesTab: "Studies",
      newsTab: "Lab News",
      appointmentRequests: "Appointment Requests",
      manageRequests: "Manage incoming appointment requests",
      noAppointments: "No appointments",
      surnameCol: "Surname",
      emailCol: "Email",
      childCol: "Child",
      studyCol: "Study",
      statusCol: "Status",
      actionsCol: "Actions",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      suggested: "New Suggested",
      suggestNewDate: "Suggest new date",
      time: "Time",
      suggest: "Suggest",
      addTimeSlot: "Add New Time Slot",
      addTimeSlotDesc: "Create a time slot with both sessions",
      session1Date: "Session 1 - Date",
      session1Time: "Session 1 - Time",
      session2DateAuto: "Session 2 - Date (automatically 7 days later)",
      session2Time: "Session 2 - Time",
      addSlotBtn: "Add Time Slot",
      availableSlots: "Available Time Slots",
      availableSlotsDesc: "List of all booking slots",
      noSlots: "No time slots available",
      booked: "Booked",
      addStudy: "Add New Study",
      addStudyDesc: "Create a new study for bookings",
      studyName: "Study Name",
      studyNamePlaceholder: "e.g. Spark, Memory Test",
      studyDescription: "Description (optional)",
      studyDescPlaceholder: "Brief description of the study",
      addStudyBtn: "Add Study",
      activeStudies: "Active Studies",
      activeStudiesDesc: "List of all available studies",
      noStudies: "No studies available",
      addNews: "Add Announcement",
      addNewsDesc: "Create a new Lab News announcement",
      newsTitleDe: "Title (German)",
      newsTitleEn: "Title (English)",
      newsDescDe: "Description (German)",
      newsDescEn: "Description (English)",
      newsLink: "Link (optional)",
      newsLinkPlaceholder: "https://...",
      addNewsBtn: "Add Announcement",
      allNews: "All Announcements",
      allNewsDesc: "List of all Lab News",
      noNews: "No announcements"
    },
    // Studies page
    studiesPage: {
      title: "Our Studies",
      subtitle: "Learn more about our current research projects and how you can participate.",
      researchFocus: "Research Focus",
      researchDesc: "Childhood and aging are marked by dramatic changes in learning, memory and cognitive control. We examine how these processes interact throughout the lifespan and how brain development, experience, and environmental factors shape their developmental trajectories.",
      currentStudies: "Current Studies",
      kidsInAction: "Kids in Action",
      kidsInActionDesc: "Our 'Kids in Action' study investigates children's ability to remember various things, predict their actions, and solve problems.",
      ageRange: "Age: 4-10 years",
      lamaStudy: "Lama Study",
      lamaStudyDesc: "Our 'Lama' study investigates children's categorization and memory abilities.",
      stressStudy: "Stress and Curiosity Study",
      stressStudyDesc: "This study investigates the relationship between stress and curiosity. Participants answer trivia questions and undergo a stress test.",
      adults: "Adults",
      compensation: "Compensation: €15/h or 1 credit/h",
      duration: "Duration: approx. 2 hours",
      contact: "Contact",
      interested: "Interested? Contact us!",
      participate: "Participate Now"
    },
    // Publications page
    publications: {
      title: "Publications",
      subtitle: "Scientific publications from our team",
      requestPdf: "If you would like to receive any of our publications as a PDF, please feel free to request them via:",
      journalArticles: "Journal Articles",
      labPosters: "Lab Poster Presentations"
    },
    // News page
    news: {
      title: "Lab News",
      subtitle: "Latest news and announcements from our laboratory",
      noNews: "No news at the moment.",
      readMore: "Read more"
    }
  }
};
